class PriceChange {
    constructor() {
        this.labels = document.querySelectorAll(".variant-input input");
        this.prices = [];

        let priceData = document.querySelectorAll(".SetPrice");
        for (let i = 0; i < priceData.length; i++) {
            this.prices.push(priceData[i].innerHTML);
        }

        for (let i = 0; i < this.labels.length; i++) {  
            this.labels[i].onclick = () => {
                var x = this.prices[i];
                this.reWrite(x);
            }
        }
    }

    reWrite(n) {
        let price = document.querySelectorAll(".product__price");
        let priceLength = price.length;
        let _class = "tax";
        for (let i = 0; i < priceLength; i++) {
            price[i].style.opacity = 0;
            price[i].style.transition = "all 0s";
        }
      
        setTimeout(() => {
            for (let i = 0; i < priceLength; i++) {
                price[i].style.transition = "all 0.5s";
            }
        }, 1);
        
        setTimeout(() => {
            for (var i = 0; i < priceLength; i++) {
                price[i].innerHTML = n + "円<span class='" + _class + "'>（税込)</span>";
                price[i].style.opacity = 1;
            }

            var reset = document.querySelectorAll("#stop .variant-input-wrap label");
            for (let i = 0; i < reset.length; i++) {
                reset[i].style.backgroundColor = "#262626";
                reset[i].style.color = "#d6d6d6";
            }
        }, 100);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    new PriceChange();
});